module.exports = __webpack_public_path__ + "assets/shake-token.6f74aada.svg";